(function () {
  if (!document.querySelector && !window.addEventListener && !("classList" in document.createElement("p"))) return;

  /*
    Utillity functions
  */
  var ready = function (callback, ctx) {
    if (typeof callback !== 'function') return;
    if (document.readyState !== "loading") {
      callback.apply(ctx);
    } else {
      document.addEventListener("DOMContentLoaded", function () {
        callback.apply(ctx);
      });
    }
  };

  var debounce = function (callback, wait, ctx) {
    var timeout, timestamp, args;
    wait = wait || 100;
    var later = function() {
      var last = new Date().getTime() - timestamp;
      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        callback.apply(ctx, args);
      }
    };
    return function () {
      ctx = ctx || this;
      args = arguments;
      timestamp = new Date().getTime();
      if (!timeout) timeout = setTimeout(later, wait);
    };
  };

  /*
    Sticky product form
  */
  var StickyFormBar = function () {
    this.selectors = {
      formBar: '.product-single__form-bar'
    };
    this.classes = {
      templateFixed: 'template-product--fixed',
      formBarFixed: 'product-single__form-bar--fixed',
      formBarVisible: 'product-single__form-bar--fixed-visible'
    };
    this.init();
  };

  StickyFormBar.prototype.init = function () {
    this._getElements();
    this._addEventListeners();
  };

  StickyFormBar.prototype.checkIfSticky = function () {
    var formBarParentBoundingRect = this.formBarParent.getBoundingClientRect();
    var formBarParentOffset = formBarParentBoundingRect.top + formBarParentBoundingRect.height;
    if (formBarParentOffset < 0) {
      this.makeSticky();
    } else {
      this.makeUnsticky();
    }
  };

  StickyFormBar.prototype.makeSticky = function () {
    // Set padding on the parent container so the page doesn't jump up
    var formBarHeight = this.formBar.getBoundingClientRect().height;
    this.formBarParent.style.paddingBottom = formBarHeight + 'px';
    this.body.style.paddingBottom = formBarHeight + 'px';

    this.body.classList.add(this.classes.templateFixed);
    this.formBar.classList.add(this.classes.formBarFixed);

    var _this = this;
    setTimeout(function () {
      _this.formBar.classList.add(_this.classes.formBarVisible);
    }, 500);
  };

  StickyFormBar.prototype.makeUnsticky = function () {
    // Reset padding on the parent container
    this.formBarParent.style.paddingBottom = '';
    this.body.style.paddingBottom = '';
    this.body.classList.remove(this.classes.templateFixed);
    this.formBar.classList.remove(this.classes.formBarFixed);
    this.formBar.classList.remove(this.classes.formBarVisible);
  };

  // Private
  StickyFormBar.prototype._getElements = function () {
    this.body = document.querySelector('body');
    this.formBar = document.querySelector(this.selectors.formBar);
    this.formBarParent = this.formBar.parentNode;
  };

  StickyFormBar.prototype._addEventListeners = function () {
    var _this = this;
    window.addEventListener('scroll', function (e) {
      _this.checkIfSticky();
    });

    window.addEventListener('resize', debounce(function (e) {
      _this.checkIfSticky();
    }));
  };

  /*
    Run on page load
  */
  ready(function () {
    new StickyFormBar();
  });
})();
